


































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import searchForm from './form';
import {
  getMonthEndDate,
  getMonthStartDate,
} from '@/modules/FPKG-20000-Util/prototypes/TimeLib';

@Component
export default class componentName extends Vue {
  @Prop({
    default() {
      return [];
    },
  })
  private dpeInfo: any;

  private searchForm: {} = searchForm;

  private form: any = {};

  private DepartmentInfo: Array<Object> = [];

  private advSearch() {
    this.form.page = 1;
    const query: any = { ...this.$route.query, ...this.form };
    query.t = Date.now();
    delete query.search_complex;
    this.$emit('close');
    this.$router.push({ query });
  }

  private resetForm(formName: string) {
    this.form = {};
    const { path } = this.$route;
    this.$emit('close');
    this.$router.push(path);
  }

  private mounted() {
    const { query } = this.$route;
    const querySetting = JSON.parse(JSON.stringify(query));
    if (querySetting.length > 0) {
      this.form = querySetting;
    } else {
      const s1 = getMonthStartDate();
      const s2 = getMonthEndDate();
      this.$set(this.form, 'search_p9_ton_created_at_start', `${s1} 00:00:00`);
      this.$set(this.form, 'search_p9_ton_created_at_end', `${s2} 23:59:59`);
    }
  }
}
